var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMessageLinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 52 52"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M1 26C1 39.8071 12.1929 51 26 51C39.8071 51 51 39.8071 51 26C51 12.1929 39.8071 1 26 1C21.232 1 16.7757 2.33479 12.9845 4.65109M14 19.5V18C14 16.8954 14.8954 16 16 16H37C38.1046 16 39 16.8954 39 18V30.625C39 31.7296 38.1046 32.625 37 32.625H23.3757C23.1335 32.625 22.8995 32.7129 22.7172 32.8724L18.8293 36.2744C18.506 36.5573 18 36.3277 18 35.8981V33.125C18 32.8489 17.7761 32.625 17.5 32.625H16C14.8954 32.625 14 31.7296 14 30.625V25.0625"
})));
export default SvgMessageLinline;